export const PKG_NAME = '@vitus-labs/elements' as const
